export default function DisclaimerBanner() {
  return (
    <div
      data-testid="disclaimer-banner"
      className="flex items-center gap-2 px-4 py-2 text-sm border-b"
      style={{ backgroundColor: '#FFF4DF', borderColor: '#E0B96F', color: '#5C3B0E' }}
    >
      <img src="/brand/logo-round.png" alt="" className="w-4 h-4 rounded-full shrink-0" />
      <span>Educational use only. Not a substitute for professional medical advice.</span>
    </div>
  );
}
